import {
  ExamSubject,
  PredictionOfPassedContainer_ExamGradingResultFragment,
} from 'generated/graphql'

export type GenerateqTableReturnData = {
  answeredCount?: number
  correctCount?: number
  correctRate?: number
  allUserAverageAnsweredCount?: number
  allUserAverageCorrectCount?: number
  allUserAverageCorrectRate?: number
  top30UserAverageAnsweredCount?: number
  top30UserAverageCorrectCount?: number
  top30UserAverageCorrectRate?: number
  sameInfoAverageAnsweredCount?: number
  sameInfoAverageCorrectCount?: number
  sameInfoAverageCorrectRate?: number
  top30SameInfoAverageAnsweredCount?: number
  top30SameInfoAverageCorrectCount?: number
  top30SameInfoAverageCorrectRate?: number
}

export type TableDataListType = {
  math: GenerateqTableReturnData
  reasoning: GenerateqTableReturnData
}

type GenerateqTableDataFn = (
  examGradingResultData: PredictionOfPassedContainer_ExamGradingResultFragment,
  subject: ExamSubject,
) => GenerateqTableReturnData

export const generateTableData: GenerateqTableDataFn = (
  examGradingResultData,
  subject,
) => {
  const myAnswerData = examGradingResultData?.viewerResult.detail.find(
    (item) => {
      return item.subject === subject
    },
  )

  const allUserAverageData =
    examGradingResultData?.overallExamGradingResult.detail.find((item) => {
      return item.subject === subject
    })

  const top30UserAverageData =
    examGradingResultData?.top30percentOfOverallExamGradingResult.detail.find(
      (item) => {
        return item.subject === subject
      },
    )

  const sameInfoAverageData =
    examGradingResultData?.subsidiaryJobExamGradingResultOfSameInfo.detail.find(
      (item) => {
        return item.subject === subject
      },
    )

  const top30SameInfoAverageData =
    examGradingResultData?.subsidiaryJobtop30percentExamGradingResultOfSameInfo.detail.find(
      (item) => {
        return item.subject === subject
      },
    )

  return {
    answeredCount: myAnswerData?.answeredCount,
    correctCount: myAnswerData?.correctCount,
    correctRate: myAnswerData?.correctRate,
    allUserAverageAnsweredCount: allUserAverageData?.answeredCount,
    allUserAverageCorrectCount: allUserAverageData?.correctCount,
    allUserAverageCorrectRate: allUserAverageData?.correctRate,
    top30UserAverageAnsweredCount: top30UserAverageData?.answeredCount,
    top30UserAverageCorrectCount: top30UserAverageData?.correctCount,
    top30UserAverageCorrectRate: top30UserAverageData?.correctRate,
    sameInfoAverageAnsweredCount: sameInfoAverageData?.answeredCount,
    sameInfoAverageCorrectCount: sameInfoAverageData?.correctCount,
    sameInfoAverageCorrectRate: sameInfoAverageData?.correctRate,
    top30SameInfoAverageAnsweredCount: top30SameInfoAverageData?.answeredCount,
    top30SameInfoAverageCorrectCount: top30SameInfoAverageData?.correctCount,
    top30SameInfoAverageCorrectRate: top30SameInfoAverageData?.correctRate,
  }
}
